import { TicketDTO } from 'core/api';

import * as Division from './Division';
import { Result } from 'core/infrastructure';
import { ThemeManager } from 'pos/ui';
import { PhoneOrTabletDivisionScreen } from './PhoneOrTabletDivisionScreen';
import WebPosDivisionScreen from './WebPosDivisionScreen';
import { Message, Modal } from 'core/ui-next/modal';


export async function splitTicketLinesManual(ticket: TicketDTO): Promise<Result> {

	const result = await Division.initManual(ticket);
	if (!result.ok) {
		await Message.show(result.error.message);
		return Result.error();
	}

	const Screen = ThemeManager.selectScreen({ Phone: PhoneOrTabletDivisionScreen, Tablet: PhoneOrTabletDivisionScreen, WebPos: WebPosDivisionScreen });
	return Modal.show(Screen, { initialStatus: result.value, tableCompanions: ticket.TableCompanions });
}

export async function splitTicketLinesAuto(ticket: TicketDTO, parts: number): Promise<Result> {

	const result = await Division.initAuto(ticket, 0, parts);
	if (!result.ok) {
		await Message.show(result.error.message);
		return Result.error();
	}

	const Screen = ThemeManager.selectScreen({ Phone: PhoneOrTabletDivisionScreen, Tablet: PhoneOrTabletDivisionScreen, WebPos: WebPosDivisionScreen });
	return Modal.show(Screen, { initialStatus: result.value, tableCompanions: ticket.TableCompanions });
}